import getLocalString from "constants/Localization";
import { useUpdateOrganizationMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateOrganization() {
  const [mutation, { loading, data, error }] = useUpdateOrganizationMutation();
  const [updateOrganization, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateOrganization",
    },
    {
      successMessage: getLocalString("organization.update-success"),
      failureMessage: getLocalString("organization.update-failure"),
    }
  );

  return [updateOrganization, context] as const;
}
